(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clinical-report"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let slider, slides, prev, next, pagination;
    let visible = 3;
    let page = 0;
    let dots = [];
    let resizeTimer;

    function initSlider() {
      slider = document.querySelector('.ccs-slider');
      if (!slider) return;

      slides = slider.querySelectorAll('.ccs-slide');
      prev = document.querySelector('.ccs-nav.prev');
      next = document.querySelector('.ccs-nav.next');
      pagination = document.querySelector('.ccs-pagination');

      /* ===== Reset everything first (IMPORTANT) ===== */
      slider.style.transform = 'none';
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      if (pagination) pagination.style.display = 'none';
      if (pagination) pagination.innerHTML = '';
      dots = [];
      page = 0;

      if (window.innerWidth <= 767) {
        return;
      }

      visible = window.innerWidth < 1200 ? 2 : 3;

      if (slides.length <= visible) {
        return;
      }

      if (prev) prev.style.display = 'block';
      if (next) next.style.display = 'block';
      if (pagination) pagination.style.display = 'flex';

      const totalPages = Math.ceil(slides.length / visible);

      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('span');
        dot.className = 'ccs-dot' + (i === 0 ? ' active' : '');
        dot.addEventListener('click', () => {
          page = i;
          updateSlider();
        });
        pagination.appendChild(dot);
        dots.push(dot);
      }

      updateSlider();
    }

    function updateSlider() {
      if (!slides.length) return;

      const slideWidth = slides[0].offsetWidth;
      const maxTranslate = slides.length * slideWidth - visible * slideWidth;

      let translateX = page * slideWidth * visible;

      if (translateX > maxTranslate) {
        translateX = maxTranslate;
      }

      slider.style.transform = `translateX(-${translateX}px)`;

      if (prev) prev.disabled = page === 0;
      if (next) next.disabled = page === dots.length - 1;

      dots.forEach((d) => d.classList.remove('active'));
      if (dots[page]) dots[page].classList.add('active');
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('.ccs-nav.next')) {
        if (page < dots.length - 1) {
          page++;
          updateSlider();
        }
      }

      if (e.target.closest('.ccs-nav.prev')) {
        if (page > 0) {
          page--;
          updateSlider();
        }
      }
    });

    initSlider();

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initSlider();
      }, 250);
    });
  });

  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('.open-modal');
    if (openBtn) {
      const modal = document.getElementById(openBtn.dataset.modal);
      if (modal) {
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      }
    }

    if (e.target.classList.contains('close-btn')) {
      e.target.closest('.modal-overlay').style.display = 'none';
      document.body.style.overflow = 'auto';
    }

    if (e.target.classList.contains('modal-overlay')) {
      e.target.style.display = 'none';
      document.body.style.overflow = 'auto';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clinical-summary"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('.open-summary-modal');
    if (openBtn) {
      const wrapper = openBtn.closest('.lcresultone');
      if (!wrapper) return;

      const modal = wrapper.querySelector('.second-modal-overlay');
      if (!modal) return;

      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    if (e.target.classList.contains('second-close-btn')) {
      const modal = e.target.closest('.second-modal-overlay');
      modal.style.display = 'none';
      document.body.style.overflow = 'auto';
    }

    if (e.target.classList.contains('second-modal-overlay')) {
      e.target.style.display = 'none';
      document.body.style.overflow = 'auto';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
